import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {SCORES_BAR} from "../scores-bar-widget.consts";
import {ScoresBarWidgetState} from "../models/scores-bar-widget.state";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {CalendarClickEvent} from "../../../core/models/events/calendar-click-event";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";

export class ScoresBarWidgetCalendarClickHandler extends AnalyticsEventHandler {
  state: ScoresBarWidgetState;
  datetimeUtils: DatetimeUtils;
  type = SCORES_BAR.ACTION_TYPES.calendarClick;

  static injectables = [...ActionHandler.injectables, AnalyticsService, DatetimeUtils];

  constructor(analyticsService: AnalyticsService, datetimeUtils: DatetimeUtils) {
    super(analyticsService);

    this.datetimeUtils = datetimeUtils;
    this.eventType = CalendarClickEvent;
  }

  action(params) {
    const datesInterval: Number = this.datetimeUtils?.diffDaysByDate(params.date);
    const event: CalendarClickEvent = new CalendarClickEvent({
      datesInterval,
      source: params.source,
      clickType: params.clickType
    });

    this.analyticsService.createEvent(event);
  }
}

